<div class="table-container-2">
    <h2 class="mat-h2">Loss Details</h2>
    <form [formGroup]="form" class=" mt-4">
      <div class="form-container">
        <div class="field-container">
          <mat-form-field class="full-width" appearance="outline">
            <mat-label>Loss Date</mat-label>
            <input
              matInput
              [matDatepicker]="accidentDatePicker"
              #accidentDate
              formControlName="accidentDate"
              data-test="accidentDate-form-field"
              readonly
            />
            <mat-datepicker-toggle matIconSuffix [for]="accidentDatePicker"></mat-datepicker-toggle>
            <mat-datepicker #accidentDatePicker></mat-datepicker>
          </mat-form-field>
        </div>
        <div class="field-container">
          <mat-form-field appearance="outline" class="full-width">
            <mat-label>Loss Time</mat-label>
            <input
              matInput
              type="time"
              formControlName="accidentTime"
              data-test="accidentTime-form-field"
            />
          </mat-form-field>
        </div>
        <div class="field-container">
          <mat-form-field appearance="outline" class="full-width">
            <mat-label>Loss Location</mat-label>
            <input
              matInput
              formControlName="accidentLocation"
              data-test="accidentLocation-form-field"
            />
          </mat-form-field>
        </div>
        <div class="field-container">
          <mat-form-field appearance="outline" class="full-width">
            <mat-label>Loss Description</mat-label>
            <textarea
              matInput
              formControlName="description"
              maxlength="200"
              data-test="description-form-field"
              matTextareaAutosize
              matAutosizeMinRows="6"
            ></textarea>
          </mat-form-field>
        </div>
        <div class="field-container">
          <mat-form-field appearance="outline" class="full-width">
            <mat-label>Conditions</mat-label>
            <input matInput formControlName="conditions" data-test="conditions-form-field" />
          </mat-form-field>
        </div>
        <div class="field-container">
          <div class="field-label">Weather:</div>
          <div class="margin-top-md">
            <div class="flex flex-row checkbox-group">
              <mat-checkbox style="flex: 1 1 33%" formControlName="weatherClear">Clear</mat-checkbox>
              <mat-checkbox style="flex: 1 1 33%" formControlName="weatherCloudy">Cloudy</mat-checkbox>
              <mat-checkbox style="flex: 1 1 33%" formControlName="weatherFog">Fog</mat-checkbox>
            </div>
            <div class="flex flex-row checkbox-group">
              <mat-checkbox style="flex: 1 1 33%" formControlName="weatherSleet">Sleet</mat-checkbox>
              <mat-checkbox style="flex: 1 1 33%" formControlName="weatherSnow">Snow</mat-checkbox>
              <mat-checkbox style="flex: 1 1 33%" formControlName="weatherRain">Rain</mat-checkbox>
            </div>
          </div>
        </div>
      </div>
    </form>
  </div>